<template>

  <div id="text">

    <article class="message">
      <div class="message-body">
        <div class="title is-5">The impact of British investigative journalism, 1800-2020</div>

        <div class="text">This pie chart shows the proportion of investigations that led to changes in society, against those that did not.</div>
        <div class="text">This chart allows the viewer to better explore how the nature of British investigative journalism has affected our lives over time.</div>
        <div class="text">James T. Hamilton has set out the economic value of investigative journalism to American society. Undertaking a similar task for the UK would be more difficult, given the lack of collective professional identify in the field (and the resources such bodies, like Investigative Reporters and Editors Inc. make possible). Nonetheless, with work, it may be possible to undertake such a task, which might contribute to raising the profile, and hence the professional impact of the field, in time.</div>
        <div class="text">This resource is currently populated with dummy data.</div>
      </div>
    </article>

      <div id="pie-chart">
        <GChart
          :settings="{ packages: ['corechart']}"
          type="PieChart"
          :options="chartOptions"
          style="width: 900px; height: 500px;"
          @ready="onChartReady"
          ref="gChart"
        />
      </div>



  </div>

</template>

<script>

  import { GChart } from "vue-google-charts";
  import  { dataService } from "../services/data.service";

      export default {
          name: "PieChart",
          props: {
            mydata : []
          },
          components: {
            GChart
          },
          data() {
              return {
                  chartData: this.mydata,
                  chartOptions: {
                    title: 'Impact comparison : 2000 - 2020',
                    colors: ['#9ae2ff','#D6F1FF'],
                    width: 900,
                    height: 500
                  },
                  impact: 0,
                  noImpact: 0
              }
          },
          methods: {
              onChartReady(chart, google) {
                  // now we have google lib loaded. Let's create data table based using it.
                  this.createDataTable(chart, google);
              },
              // Array will be automatically processed with visualization.arrayToDataTable function
              createDataTable(chart, google) {
                  var container = document.getElementById('pie-chart');
                  var chart = new google.visualization.PieChart(container);


                    var data = new google.visualization.DataTable();
                    data.addColumn('string', 'count');
                    data.addColumn('number', 'Impact');

                    for(let index in this.chartData) {
                      if(this.chartData.hasOwnProperty(index)){
                         if(this.chartData[index].gatekeeping === 0) {
                           this.noImpact++;
                         }
                         else{
                           this.impact++
                         }
                      }
                    }
                    data.addRow(['Impact', this.impact]);
                    data.addRow(['No impact', this.noImpact]);
                    chart.draw(data, this.chartOptions);
              }
          }
    }
</script>

<style scoped>

  #pie-chart{
    width: 900px;
    height: 500px;
  }

  #text {
    width: 100%;
  }

  .text {
    padding: 5px 0;
    width: 100%;
  }

  em {
    font-weight: 500
  }


</style>
